"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMilitaryTypesService = exports.useRuralTypesService = exports.useMilitaryCitiesService = exports.useStatesService = void 0;
const features_1 = require("../../features");
const hooks_1 = require("../../hooks");
const useStatesService = () => {
    const { call: getStatesCall, isLoading: isGetStatesLoading, isError: isGetStatesError, isSuccess: isGetStatesSuccess, data: statesData, } = (0, hooks_1.useAsyncStateInfo)(features_1.getStates);
    return {
        getStatesCall,
        isGetStatesLoading,
        isGetStatesError,
        isGetStatesSuccess,
        statesData,
    };
};
exports.useStatesService = useStatesService;
const useMilitaryCitiesService = () => {
    const { call: getMilitaryCitiesCall, isLoading: isGetMilitaryCitiesLoading, isError: isGetMilitaryCitiesError, isSuccess: isGetMilitaryCitiesSuccess, data: militaryCitiesData, } = (0, hooks_1.useAsyncStateInfo)(features_1.getMilitaryCities);
    return {
        getMilitaryCitiesCall,
        isGetMilitaryCitiesLoading,
        isGetMilitaryCitiesError,
        isGetMilitaryCitiesSuccess,
        militaryCitiesData,
    };
};
exports.useMilitaryCitiesService = useMilitaryCitiesService;
const useRuralTypesService = () => {
    const { call: getRuralTypesCall, isLoading: isGetRuralTypesLoading, isError: isGetRuralTypesError, isSuccess: isGetRuralTypesSuccess, data: ruralTypesData, } = (0, hooks_1.useAsyncStateInfo)(features_1.getRuralTypes);
    return {
        getRuralTypesCall,
        isGetRuralTypesLoading,
        isGetRuralTypesError,
        isGetRuralTypesSuccess,
        ruralTypesData,
    };
};
exports.useRuralTypesService = useRuralTypesService;
const useMilitaryTypesService = () => {
    const { call: getMilitaryTypesCall, isLoading: isGetMilitaryTypesLoading, isError: isGetMilitaryTypesError, isSuccess: isGetMilitaryTypesSuccess, data: militaryTypesData, } = (0, hooks_1.useAsyncStateInfo)(features_1.getMilitaryTypes);
    return {
        getMilitaryTypesCall,
        isGetMilitaryTypesLoading,
        isGetMilitaryTypesError,
        isGetMilitaryTypesSuccess,
        militaryTypesData,
    };
};
exports.useMilitaryTypesService = useMilitaryTypesService;
//# sourceMappingURL=useAddressModalConfigService.hook.js.map